import makeAPIRequest from "../../services/makeRequest";
import config from "../../config";

async function updateNotification(accessToken, notificationId, payload) {
  const API_ENDPOINT = `${config["API_BASE_ENDPOINT"]}/admin/notification/${notificationId}`;

  const response = await makeAPIRequest(API_ENDPOINT, "PUT", payload, accessToken);
  const jsonResponse = await response.json();
  return jsonResponse;
}

export default updateNotification;
